export default __webpack_public_path__ + "locales/zh-CN/InfoPanel.json?hash=0612b1c1fcc25f48d6d2a808c7bb4d8d";